import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
/**
 * "Back to products" link at the bottom of the Gen3 E-Foot Gear page.
 */
export function BackLink() {
  return <div className="mt-10" data-id="element-401">
      <button type="button" onClick={() => window.history.back()} className="inline-flex items-center gap-2 text-sm font-semibold text-gray-700 hover:text-red-600 transition-colors" data-id="element-402">
        <ChevronLeftIcon className="w-4 h-4" data-id="element-403" />
        Back to products
      </button>
    </div>;
}